import React from "react"

// Shared marketing header. Used on both the home page (App.jsx) and
// the /audit cold-outreach landing (AuditView.jsx). Anchor links
// (#how-it-works / #pricing / #faq) only resolve on the home page —
// on /audit they no-op since those sections aren't rendered. That's
// intentional: the audit page is a focused conversion funnel, not the
// full pitch deck.
export default function Header({ showAnchorLinks = true }) {
  return (
    <header className="px-6 py-5 border-b border-[color:var(--color-rule)]">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <a href="/" className="font-sans text-[15px] tracking-[-0.025em] font-medium">
          ShopShift<span className="text-[color:var(--color-ai)]">.</span>
        </a>
        <nav className="flex items-center gap-6 font-sans text-[13px] text-[color:var(--color-ink-secondary)]">
          {showAnchorLinks && (
            <>
              <a href="#how-it-works" className="hidden sm:inline hover:text-[color:var(--color-ink-primary)]">
                How it works
              </a>
              <a href="#pricing" className="hidden sm:inline hover:text-[color:var(--color-ink-primary)]">
                Pricing
              </a>
              <a href="#faq" className="hidden sm:inline hover:text-[color:var(--color-ink-primary)]">
                FAQ
              </a>
            </>
          )}
          {!showAnchorLinks && (
            <a href="/" className="hidden sm:inline hover:text-[color:var(--color-ink-primary)]">
              Home
            </a>
          )}
          <a href="/users/sign_in" className="hover:text-[color:var(--color-ink-primary)]">
            Sign in
          </a>
        </nav>
      </div>
    </header>
  )
}
